module.exports = __webpack_public_path__ + "img/yaowenbin.0121b081.jpg";